import React from 'react';
import { IAuditoriaSocietariaResultado } from '../interfaces/IAuditoriaSocietaria';
import { TributoAuditoria } from '../interfaces/IAuditoria';

interface Props {
  resultado?: IAuditoriaSocietariaResultado;
  onSelecionar: (tributo: TributoAuditoria) => void;
}

const formatCurrency = (value?: number) =>
  (value || 0).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });

const AuditoriaResumoSocietaria: React.FC<Props> = ({ resultado, onSelecionar }) => {
  if (!resultado) {
    return null;
  }

  const totalContas = resultado.capitalSocial?.length || 0;

  return (
    <div className='auditoria-card mt-5'>
      <h3>Resumo de Auditoria Societária — Capital Social vs. Registro na Receita Federal</h3>
      <p className='text-muted'>
        Cruzamento do saldo consolidado de Capital Social / Capital Subscrito (referencial ECD 2.03.01.*) com o
        valor registrado na Receita Federal (base JUCESP) — AFAC, Sócios/Quotas e Capital a Integralizar são
        auditados à parte, sem gerar divergência de Capital Social. Divergência sujeita à multa ECD potencial
        (5% limitada a 1% da receita bruta do período — Art. 12, II, Lei 8.218/1991). Clique para ver a análise detalhada.
      </p>

      <div className='table-responsive mt-4'>
        <table className='auditoria-table auditoria-table-tributos'>
          <thead>
            <tr>
              <th>Auditoria</th>
              <th className='text-end'>Impacto Fiscal Estimado</th>
              <th className='text-center'>Erros</th>
              <th className='text-center'>Avisos</th>
              <th className='text-center'>Alertas</th>
            </tr>
          </thead>

          <tbody>
            <tr className='auditoria-row-tributo' onClick={() => onSelecionar('AUDITORIA_SOCIETARIA')}>
              <td className='auditoria-col-tributo'>
                <div className='d-flex align-items-center gap-2'>
                  <strong>Auditoria Societária — Capital Social</strong>
                  <span className={`auditoria-status status-${resultado.status}`}>
                    {resultado.status}
                  </span>
                </div>
                <div className='auditoria-legislacao-inline'>
                  <div>
                    {totalContas} conta{totalContas === 1 ? '' : 's'} de Capital Social analisada{totalContas === 1 ? '' : 's'} no período
                  </div>
                  <div className='text-muted'>{resultado.mensagemDirecionamento}</div>
                </div>
              </td>
              <td className='text-end auditoria-col-highlight'>
                {formatCurrency(resultado.impactoFiscalTotal)}
                <div className='auditoria-kpi-help'>Multa ECD potencial — 5% sobre a divergência entre ECD e registro na Receita Federal, limitada a 1% da receita bruta (Art. 12, II, Lei 8.218/1991)</div>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-erro'>{resultado.totalErros}</span>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-aviso'>{resultado.totalAvisos}</span>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-alerta'>{resultado.totalAlertas}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AuditoriaResumoSocietaria;
